export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14725.d99b53b0.jpg";